// extracted by mini-css-extract-plugin
module.exports = {"hero-border":"HeroBorder_hero-border__LDVZO"};